<template lang="pug">
    el-dialog(title="报名管理",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="handData",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="培训ID" prop="matchId")
                    div.width_label {{handData.trainCode}}
                el-form-item(label="培训名称" prop="matchName")
                    div.width_label {{handData.name}}
                el-form-item(label="培训类型")
                    div.width_label {{pxType[handData.type]}}
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{handData.orgName}}
                el-form-item(label="状态")
                    div.width_label {{pxState[handData.state]}}
            el-row(style="padding-top:30px")
                el-col(:span="24")
                    el-button(type="primary" @click="addOrUpdateBench(null,1)" :disabled="isDesabled") 添加报名信息
                    el-button(type="danger" @click="delEnroll(null)" :disabled="enrollDataOneChange.length<1||isDesabled") 删除
            el-row(style="padding-top:10px")
                el-col(:span="24")
                        el-table(:data="enrollDataOne" border @selection-change="enrollOneChange")
                                el-table-column(type='selection', header-align='center', align='center', width='50')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column(prop="phone" label="手机号" align='center' )
                                el-table-column(prop="type" label="培训类型" align='center' )
                                    template(slot-scope="scope")
                                        font {{groupPxType[scope.row.type]}}
                                el-table-column(prop="trainNum" label="培训人数" align='center' )
                                el-table-column(prop="trainStr" label="开始培训时间" align='center')
                                    template(slot-scope="scope")
                                        font {{scope.row.trainStr.slice(0,10)}}
                                el-table-column(prop="trainEnd" label="结束培训时间" align='center')
                                    template(slot-scope="scope")
                                        font {{scope.row.trainEnd.slice(0,10)}}
                                el-table-column(prop="address" label="培训地点" align='center')
                                el-table-column(prop="note" label="备注" align='center' )
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="true" )
                                            el-submenu(index="1")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group()
                                                    el-menu-item(index="1-1" @click="addOrUpdateBench(scope.row,2)") 修改
                                                    el-menu-item(index="1-2" @click='delEnroll(scope.row.id)' :disabled="isDesabled") 删除
            el-dialog(:title="handtitle" :visible.sync="addVisible" width="40%" :append-to-body='true' :modal-append-to-body='false' @close="addClose")
                el-row
                    el-col()
                      el-form(:model="addPerForm" ref="addPerFormRef" :rules="addFormRul" style="padding:30px;" label-width="100px")
                        el-form-item(label="姓名" prop="name")
                            el-input(v-model='addPerForm.name' clearable='', style='width:80%;' )
                        el-form-item(label="手机号" prop="phone")
                            el-input(v-model='addPerForm.phone' clearable='', style='width:80%;' )
                        el-form-item(label="培训类型" prop="type")
                            el-select(v-model='addPerForm.type' clearable='', style='width:80%;')
                                el-option(v-for="item in pXtypeOptions" :key="item.value" :label="item.label" :value="item.value")
                        el-form-item(label="培训人数" prop="trainNum")
                            el-input(v-model='addPerForm.trainNum' clearable='', style='width:80%;' )
                        el-form-item(label="培训时间" prop="pxdate")
                            el-date-picker( style='width:80%;'  v-model='addPerForm.pxdate' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp")
                        el-form-item(label="培训地点" prop="address")
                            el-input(v-model='addPerForm.address' clearable='', style='width:80%;' )
                        el-form-item(label="备注" prop="note" )
                            el-input(v-model='addPerForm.note' type='textarea' style='width:80%;' rows='4' resize='none')
                span.dialog-footer(slot="footer")
                    el-button(@click="addEnroll" type="primary" :disabled="clickFlag") 确 定
                    el-button(@click="addVisible=false") 取 消
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
    import commonData from '../../common.js'
    export default {
        data () {
            return {
                isDesabled: false,
                handData: '',
                enrollDataOne: [],
                enrollDataOneChange: [],
                pxType: commonData.pxType,
                pxState: commonData.pxState2,
                groupPxType: commonData.groupPxType,
                pXtypeOptions: commonData.groupPxType2,
                visible: false,
                clickFlag: false,
                handtitle: '',
                addVisible: false,
                refundVisible: false,
                addOrUpdate: 0, //0新增 1修改
                addPerForm: {
                    trainId: '',
                    name: '',
                    phone: '',
                    type: '',
                    pxdate: '',
                    trainNum: '',
                    address: '',
                    note: ''
                },
                addFormRul: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码' }
                    ],
                    type: [
                        { required: true, message: '请选择培训类型', trigger: 'blur' }
                    ],
                    pxdate: [
                        { required: true, message: '请选择培训时间', trigger: 'blur' }
                    ],
                    trainNum: [
                        { required: true, message: '请输入培训人数', trigger: 'blur' },
                        { pattern: /^[1-9]\d*$/, message: '请输入正整数' }
                    ],
                    address: [
                        { required: true, message: '请输入培训地点', trigger: 'blur' },
                        { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                    ]
                    // note: [
                    //     { required: true, message: '请输入备注', trigger: 'blur' },
                    //     { min: 2, max: 20, message: '长度在 2 到 20个字符', trigger: 'blur' }
                    // ]
                }

            }
        },
        methods: {
            openFullScreen () {
              this.loading = this.$loading({
                  lock: true,
                  text: '加载中',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              })
            },
            //添加人员入库
            addEnroll () {
                this.$refs['addPerFormRef'].validate(valid => {
                    if (valid) {
                        this.openFullScreen()
                        this.clickFlag = true
                        this.addPerForm.trainStr = this.addPerForm.pxdate[0] || ''
                        this.addPerForm.trainEnd = this.addPerForm.pxdate[1] || ''
                        this.$http({
                            url: this.$http.adornUrl(`/pxTrainGroup/${this.addOrUpdate ? 'update' : 'save'}`),
                            method: 'post',
                            data: this.addPerForm
                        }).then((data) => {
                            if (data && data.code === 0) {
                                this.$message.success('添加成功！')
                                this.addVisible = false
                                this.clickFlag = false
                                this.getTrainPerson()
                                this.loading.close()
                            } else {
                                this.$message.error('添加失败！')
                                this.loading.close()
                            }
                        }).catch(() => {
                            this.$message.error('添加失败！')
                            this.loading.close()
                        })
                    }
                })
            },
            //添加或修改事件addOrUpdate:0:新增 1:修改
            addOrUpdateBench (row, type) {
                console.log(row, 99)
                this.handtitle = { 1: '添加培训信息', 2: '修改培训信息' }[type]
                this.addOrUpdate = 0
                if (row) {
                    this.addOrUpdate = 1
                    this.addPerForm.id = row.id
                    this.addPerForm.name = row.name
                    this.addPerForm.phone = row.phone
                    this.addPerForm.type = row.type
                    this.addPerForm.pxdate = [new Date(row.trainStr).getTime(), new Date(row.trainEnd).getTime()]
                    this.addPerForm.trainNum = row.trainNum
                    this.addPerForm.address = row.address
                    this.addPerForm.note = row.note
                }
                this.addVisible = true
            },

            //删除人员
            delEnroll (id) {
                let ids = ''
                let arr = []
                if (id) {
                   ids = id
                } else {
                  this.enrollDataOneChange.forEach(e => {
                      arr.push(e.id)
                  })
                  ids = arr.join()
                }
                this.$confirm('是否删除该人员', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.$http({
                        url: this.$http.adornUrl(`/pxTrainGroup/delete/${ids}`),
                        method: 'post'
                    }).then((data) => {
                        if (data && data.code === 0) {
                            this.$message.success('删除成功！')
                            this.getTrainPerson()
                        }
                    })
                }).catch(() => {
                    this.$message.info('已取消')
                })
            },
            //查询列表
            getTrainPerson () {
                this.$http({
                    url: this.$http.adornUrl(`/pxTrainGroup/list`),
                    method: 'post',
                    data: {
                        page: 1,
                        limit: 99999,
                        trainId: this.addPerForm.trainId
                    }
                }).then((data) => {
                    if (data && data.code === 0) {
                        this.enrollDataOne = data.page.records
                    }
                })
            },
            init (row) {
                this.isDesabled = row.state == 6
                this.handData = row
                this.addPerForm.trainId = row.id || ''
                this.visible = true
                this.enrollDataOne = []
                this.enrollDataOneChange = []
                this.getTrainPerson()
            },
            //主力勾选事件
            enrollOneChange (val) {
                this.enrollDataOneChange = val
            },
            addClose () {
                this.$nextTick(() => {
                    this.$refs.addPerFormRef.resetFields()
                    this.$forceUpdate()
                })
            }
        }
    }
</script>
<style>
    .width_label{
        width:180px;
    }
    .opSetting{
        text-align: center;
        margin-top:30px;
    }
    .spacing{
        margin-top:10px;
    }
    .font_label{
        font-weight:bold;
        font-size:18px;
    }

.el-radio.is-bordered {
    width: 140px;
    padding: 12px 20px 0 10px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 40px;
}

/* 分页样式 */
.el-pager li {
    padding: 0 4px;
    font-size: 13px;
    min-width: 20.5px;
    height: 28px;
    line-height: 28px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
}
</style>
